
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tuki",
      function () {
        return require("private-next-pages/tuki.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tuki"])
      });
    }
  